import { FINSEMBLECONFIG, toGoLang, toGoLangInvoke } from "../common/windowFunctions";
const toCronDay = (dayOfWeek) => {
    if (dayOfWeek === false || typeof dayOfWeek === "undefined") {
        return "*";
    }
    return dayOfWeek.toString();
};
const computeCronTime = (value) => `${value.minute} ${value.hour} * * ${toCronDay(value.dayOfWeek)}`;
export const getDiscardUnsavedChangesSetting = async (glue) => {
    const manifest = await glue.contexts.get(FINSEMBLECONFIG) ?? {};
    const { data: tmp } = await toGoLang(() => glue.prefs.get("IO.Global.FinsemblePreferences"));
    const preferences = tmp?.data ?? {};
    return preferences?.["finsemble.scheduledCloseDiscardUnsavedChanges"] ?? manifest?.finsemble?.scheduledCloseDiscardUnsavedChanges ?? manifest?.finsemble?.servicesConfig?.workspace?.discardUnsavedChanges ?? true;
};
export const getShutdownAndRestartSetting = async (glue) => {
    const manifest = await glue.contexts.get(FINSEMBLECONFIG) ?? {};
    const { data: tmp } = await toGoLang(() => glue.prefs.get("IO.Global.FinsemblePreferences"));
    const preferences = tmp?.data ?? {};
    const shutdownSetting = preferences?.["finsemble.scheduledShutdown"] ?? manifest?.finsemble?.scheduledShutdown;
    const restartSetting = preferences?.["finsemble.scheduledRestart"] ?? manifest?.finsemble?.scheduledRestart;
    const shutdown = shutdownSetting ? computeCronTime(shutdownSetting) : undefined;
    const restart = restartSetting ? computeCronTime(restartSetting) : undefined;
    return {
        shutdown,
        restart,
    };
};
export const scheduledRestartOrShutdown = async (glue, command, value, log) => {
    const discardUnsavedLayoutChanges = await getDiscardUnsavedChangesSetting(glue);
    if (value) {
        const cronTime = computeCronTime(value);
        log("scheduledRestartOrShutdown", "start", { command, value, discardUnsavedLayoutChanges, cronTime });
        const { err } = await toGoLangInvoke(() => glue.interop.invoke("T42.GD.Execute", {
            command: `schedule-${command}`,
            args: {
                cronTime,
                title: command,
                message: `Are you sure you want to ${command}?`,
                timerDuration: 60,
                discardUnsavedLayoutChanges
            }
        }));
        if (err) {
            log("scheduledRestartOrShutdown", "error", err.toString());
        }
    }
    else {
        log("scheduledRestartOrShutdown", "start", { command, value });
        const { err } = await toGoLangInvoke(() => glue.interop.invoke("T42.GD.Execute", {
            command: `cancel-${command}`,
            args: {}
        }));
        if (err) {
            log("scheduledRestartOrShutdown", "error", err.toString());
        }
    }
    log("scheduledRestartOrShutdown", "return");
};
export const scheduledCloseDiscardUnsavedChanges = async (glue, value, log) => {
    const settings = await getShutdownAndRestartSetting(glue);
    if (settings.shutdown) {
        const cronTime = settings.shutdown;
        log("scheduledCloseDiscardUnsavedChanges", "start", { command: "shutdown", cronTime, discardUnsavedLayoutChanges: value });
        const { err } = await toGoLangInvoke(() => glue.interop.invoke("T42.GD.Execute", {
            command: "schedule-shutdown",
            args: {
                cronTime,
                title: "shutdown",
                message: "Are you sure you want to shutdown?",
                timerDuration: 60,
                discardUnsavedLayoutChanges: value
            }
        }));
        if (err) {
            log("scheduledCloseDiscardUnsavedChanges", "error", err.toString());
        }
    }
    if (settings.restart) {
        const cronTime = settings.restart;
        log("scheduledCloseDiscardUnsavedChanges", "start", { command: "restart", cronTime, discardUnsavedLayoutChanges: value });
        const { err } = await toGoLangInvoke(() => glue.interop.invoke("T42.GD.Execute", {
            command: "schedule-restart",
            args: {
                cronTime,
                title: "restart",
                message: "Are you sure you want to restart?",
                timerDuration: 60,
                discardUnsavedLayoutChanges: value
            }
        }));
        if (err) {
            log("scheduledCloseDiscardUnsavedChanges", "error", err.toString());
        }
    }
};
